export default __webpack_public_path__ + "static/media/lenses.674810b0.png";